import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const LiveHeader = ({ headerImage, lastUpdate }) => (
  <Fragment>
    <div className="live-header">
      <img src={`${process.env.PUBLIC_URL}${headerImage}`} alt="" />
      <div className="dark-overlay" />
      <div className="strip-corner">
        <div className="text">CONTENIDO PÚBLICO FINAL</div>
      </div>
      <div className="container">
        <div className="pretitle">GESTIÓN DE CONTENIDO FINAL</div>
        <div className="title">CONTENIDO PUBLICADO</div>
        <div className="subtitle">última actualización {lastUpdate}</div>
        <div className="description">Espacio donde se encuentra todo el material validado de “mis entregas” listo para
          ser usado, descargado y publicado.
        </div>
      </div>
    </div>
  </Fragment>
);

LiveHeader.propTypes = {
  headerImage: PropTypes.string.isRequired,
  lastUpdate: PropTypes.string.isRequired,
};

export default LiveHeader;

